import { useQuery } from "@tanstack/react-query";
import RestAPI from "../../../util/RestAPI";
import { FreeTrial } from "../types";
import { useUserContext } from "../../../context";

export const useFreeTrials = () => {
  const { authenticated } = useUserContext();

  const query = useQuery({
    queryKey: ["free-trial", "list"],
    queryFn: async () => {
      return await RestAPI.get("/users/list/free-trials").then(async (res) => {
        return (await res.json()) as any as FreeTrial[];
      });
    },
    staleTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    enabled: authenticated,
  });

  return query;
};
